import { PAY_MAX, inWholeCents } from "@shyne/shared/api";

export function typedMoneyProblem(text: string): string | null {
  const trimmed = text.trim();
  if (trimmed === "") return null;
  const amount = Number(trimmed);
  if (!Number.isFinite(amount) || amount < 0) return "Type an amount of $0 or more.";
  if (amount > PAY_MAX) return `Type at most $${PAY_MAX.toLocaleString("en-US")}.`;
  if (!inWholeCents(amount)) return "Type at most two decimal places.";
  return null;
}
